import { ICalculatorMcfValues } from '../../types/features';

export const replaceUndefinedWithNull = (
  obj: ICalculatorMcfValues,
): Record<string, number | string | null | undefined> =>
  Object.keys(obj).reduce(
    (acc, key: keyof ICalculatorMcfValues) => {
      acc[key] = obj[key] === undefined ? null : obj[key];

      return acc;
    },
    {} as Record<string, number | string | null | undefined>,
  );
